import * as Sentry from '@sentry/browser';
import { useCookies } from 'react-cookie';

import { FetchAnnouncementsType, PostAnnouncementsType } from '@type-def_iqfu/AnnouncementsType';

import { UserType } from '@constants_common';

const queryString = require('query-string');

const backendBasePath = process.env.NEXT_PUBLIC_DEV_BACKEND_URL;

export const useAnnouncements = () => {
  const [cookies] = useCookies(['expiry', 'access-token', 'client', 'uid', 'user-type']);

  const getAnnouncementsData = async (userType: UserType, queryParams: FetchAnnouncementsType) => {
    const query = queryString.stringify(queryParams);
    const url = `${backendBasePath}/${userType}/announcements?${query}`;

    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const createAnnouncement = async (submitData: PostAnnouncementsType) => {
    const url = `${backendBasePath}/admin/announcements`;
    const result = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submitData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const getAnnouncementDetail = async (userType: UserType, announcement_id: string) => {
    const url = `${backendBasePath}/${userType}/announcements/${announcement_id}`;
    let status;
    const result = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        if (response.status === 404) throw new Error();
        status = 'success';
        return response.json();
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
        status = 'error';
      });
    return { status, result };
  };

  const editAnnouncement = async (announcement_id: string, submitData: PostAnnouncementsType) => {
    const url = `${backendBasePath}/admin/announcements/${announcement_id}`;

    const result = await fetch(url, {
      method: 'PATCH',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(submitData),
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  const deleteAnnouncement = async (announcement_id: string) => {
    const url = `${backendBasePath}/admin/announcements/${announcement_id}`;
    const result = await fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        uid: cookies['uid'],
        client: cookies['client'],
        'access-token': cookies['access-token'],
      },
    })
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          return response.json();
        }
      })
      .catch((error) => {
        Sentry.captureException(error);
        console.error('通信に失敗しました', error);
      });
    return result;
  };

  return {
    getAnnouncementsData,
    getAnnouncementDetail,
    createAnnouncement,
    editAnnouncement,
    deleteAnnouncement,
  };
};
